import { render, staticRenderFns } from "./TenderView.vue?vue&type=template&id=52b4c71f"
import script from "./TenderView.vue?vue&type=script&lang=js"
export * from "./TenderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports